var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTumblrMobileLike = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 17,
  viewBox: "0 0 19 17",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M3.954 13.17c-.822-.686-1.93-1.854-2.449-2.476-.559-.671-.955-1.8-1.2-2.755C.091 7.104-.007 6.452.001 5.69c-.008 0 .045-1.374.537-2.639C1.126 1.54 2.345.09 4.84.09c.76 0 .232-.417 2.09.552 1.636.854 2.785 2.412 2.785 2.412-.054 0 .498-1.222 2.098-2.252.86-.554 1.593-.712 2.353-.712 2.497 0 3.767 1.45 4.356 2.963.492 1.265.44 2.639.432 2.639.008.76.014 1.413-.2 2.248-.244.956-.64 2.084-1.2 2.755-.518.622-1.626 1.79-2.448 2.476-2.577 2.152-5.498 3.75-5.498 3.75.054 0-3.078-1.598-5.655-3.75"
})));
export default SvgTumblrMobileLike;